import PublishMyVehicleButton from '../../../../components/publish-my-vehicle-button/publish-my-vehicle-button';
import publishMyVehicleButtonModule from './publish-my-vehicle-button';

export default publishMyVehicleButtonModule(PublishMyVehicleButton);
